module.exports = __webpack_public_path__ + "static/cloudwork-abb496eae9dc10076f99f663c635d487.png";